// Project
import { DRAFT_INVALID_TO_EMAIL_ADDRESS_DISPLAY, DRAFT_UPDATE_FAILURE_DISPLAY } from "../../constants/Errors";
import { DRAFT_TO_ADDRESSEES_UPDATE_FAILURE } from "../../constants/ActionTypes";
import fromFailureAction from "../util/fromFailureAction";
import isApiStatusCodeError from "../../reducers/draft/util/isApiStatusCodeError";

const messageGenerator = action => {
  const invalidEmailCode = "400";

  return isApiStatusCodeError(invalidEmailCode, action.error) ?
    DRAFT_INVALID_TO_EMAIL_ADDRESS_DISPLAY :
    DRAFT_UPDATE_FAILURE_DISPLAY;
};

const draftToUpdateFailureEpic = fromFailureAction(
  DRAFT_TO_ADDRESSEES_UPDATE_FAILURE,
  messageGenerator
);

export default draftToUpdateFailureEpic;
